import { getFunctions, httpsCallable } from 'firebase/functions'
import { getApps } from 'firebase/app'
import { refreshEntitlement } from './user'

const fns = () => getFunctions(getApps()[0], 'europe-west2')

export type Plan = 'monthly' | 'lifetime'

export async function startCheckout(plan: Plan): Promise<void> {
  const r = await httpsCallable<{ origin: string; plan: Plan }, { url: string }>(fns(), 'createCheckoutSession')({ origin: location.origin, plan })
  location.assign(r.data.url)
}

export async function openPortal(): Promise<void> {
  const r = await httpsCallable<{ origin: string }, { url: string }>(fns(), 'createPortalSession')({ origin: location.origin })
  location.assign(r.data.url)
}

/** After returning from Stripe, poll for the claim to land (webhook is async, usually <5s). */
export async function awaitEntitlement(timeoutMs = 20000): Promise<boolean> {
  const start = Date.now()
  const { isPlus } = await import('./user')
  while (Date.now() - start < timeoutMs) {
    await refreshEntitlement()
    if (isPlus()) return true
    await new Promise((r) => setTimeout(r, 2000))
  }
  return false
}
